<div class="container"
     style="max-width: 988px;margin-top: 108px;">
  <div class="col-12 py-3">
    <div class="panel p-4">
      <div class="row">
        <div class="col-md-10 d-flex flex-column">
          <strong *ngIf="result === '1'">متأسفانه پرداخت شما ناموفق بود!</strong>
          <strong *ngIf="result === '0'">پرداخت شما با موفقیت انجام شد!</strong>
          <div class="flex-grow-1 d-flex align-items-center gap-2">
            <span class="txt-light">شماره پیگیری :</span>
            <p>{{ traceCode }}</p>
          </div>
          <div class="flex-grow-1 d-flex align-items-center gap-2">
            <span class="txt-light">مبلغ :</span>
            <p>{{ amount | number }} ریال</p>
          </div>
        </div>
        <div class="col-md-2 d-flex align-items-center justify-content-center">
          <img *ngIf="result === '1'"
               src="/icons/cancel-order.png">
          <img *ngIf="result === '0'"
               src="/icons/success-order.png">
        </div>
      </div>
      <!-- <div class="col-12 mt-5" *ngIf="result === '1'">
        <p class="title mb-0">
          تغییر روش پرداخت
        </p>
      </div> -->
    </div>
  </div>
  <div *ngIf="result === '1'"
       class="panel p-4">
    <span>
      <img class="ms-4"
           src="/icons/info-circle3.svg">
      چنانچه مبلغی از حساب شما کسر شده است، تا ۷۲ ساعت آینده به حساب شما باز خواهد گشت.
    </span>
  </div>
</div>
